export default function () {
  if (import.meta.env.DEV) {
    let backendUrl = "http://".concat(import.meta.env.VITE_BASE_URL || "localhost");
    if (import.meta.env.VITE_SERVER_PORT) {
      backendUrl = backendUrl.concat(":", import.meta.env.VITE_SERVER_PORT);
    }
    return backendUrl;
  }

  if (import.meta.env.VITE_API_ORIGIN) {
    return import.meta.env.VITE_API_ORIGIN;
  }

  return window.location.origin;
}
